import {computed, observable} from 'mobx'

import * as ValueSourceType from '../../constant/ValueSourceType'

export default class OfferFieldValueSource {
    @observable source_type = ValueSourceType.IS_EMPTY
    @observable source_value = ''

    constructor(params) {
        if (params) {
            this.source_type = params.source_type
            this.source_value = params.source_value
        }
    }

    @computed get specific_value() {
        return this.isSpecific()
            ? this.source_value
            : ''
    }

    isEmpty() {
        return this.source_type === ValueSourceType.IS_EMPTY
    }

    isDefault() {
        return this.source_type === ValueSourceType.IS_DEFAULT
    }

    isSpecific() {
        return this.source_type === ValueSourceType.SPECIFIC
    }
}
